import { Card, CardContent, CardHeader, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
import LoadingSkeleton from "../../components/general/LoadingSkeleton";
import { DataGrid } from "@mui/x-data-grid";
import { Commons } from "../../helper/CommonService";
import { API_HOST, FILTER_TYPE, JENIS_BAYAR, KETERSEDIAAN } from "../../helper/Constant";
import DialogPembayaran from "../../components/Dialogs/DialogPembayaran";
import Filter from "./component/Filter";

const columns = [
  { field: 'no_daftar', headerName: 'No Daftar', width: 100 },
  { field: 'nama', headerName: 'Nama', width: 190 },
  {
    field: 'isBayarPendaftaran', headerName: 'Bayar Pendaftaran', width: 170,
    valueGetter: (value, row) => {
      return row.isBayarPendaftaran ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
    }
  },
  {
    field: 'isBayarDaftarUlang', headerName: 'Bayar Daftar Ulang', width: 170,
    valueGetter: (value, row) => {
      return row.isBayarDaftarUlang ? KETERSEDIAAN.SUDAH : KETERSEDIAAN.BELUM
    }
  }
];
const paginationModel = { page: 0, pageSize: 100 };

function Bayar() {
  const [loading, setLoading] = useState(false);
  const [pembayarans, setPembayarans] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);

  const RunFilter = (fieldName, filterValue) => {
    setLoading(true);
    loadData()
      .then(([resBayar, resSantri, resDataLain, resAyah, resIbu, resWali]) => {
        let filterSantri = PopulateData(resSantri, resBayar, resDataLain, resAyah, resIbu, resWali);
        if (fieldName) {
          filterSantri = filterSantri.filter((santri) => {
            if (santri[fieldName] === undefined) {
              return false;
            }
            return (santri[fieldName].toString().toUpperCase().includes(filterValue.toUpperCase()))
          })
        }
        setPembayarans(filterSantri);
      }).finally(() => {
        setLoading(false);
      });
  }

  const loadData = () => {
    return Promise.all(
      [
        Commons.GetData(API_HOST + "/bayar", "", true),
        Commons.GetData(API_HOST + "/santri", "", true),
        Commons.GetData(API_HOST + "/datalain", "", true),
        Commons.GetData(API_HOST + "/ayah", "", true),
        Commons.GetData(API_HOST + "/ibu", "", true),
        Commons.GetData(API_HOST + "/wali", "", true)
      ]
    );
  }

  useEffect(() => {
    setLoading(true);
    loadData()
      .then(([resBayar, resSantri, resDataLain, resAyah, resIbu, resWali]) => {
        setPembayarans(PopulateData(resSantri, resBayar, resDataLain, resAyah, resIbu, resWali));
      })
      .catch((errResp) => {
        console.log(errResp);
      })
      .finally(() => {
        setLoading(false);
      })
  }, []);

  const PopulateData = (dataSantri, dataBayar, dataLain, dataAyah, dataIbu, dataWali) => {
    return dataSantri.map((santri) => {
      let getBayar = dataBayar?.filter((x) => x.id_santri === santri.id);
      let getBayarRegistration = getBayar?.find((bayar) => bayar.type === JENIS_BAYAR.PENDAFTARAN);
      let getBayarReRegistration = getBayar?.find((bayar) => bayar.type === JENIS_BAYAR.DAFTAR_ULANG);
      let getDataLain = dataLain?.find((x) => x.id === santri.id);
      let getAyah = dataAyah?.find((x) => x.id === santri.id);
      let getIbu = dataIbu?.find((x) => x.id === santri.id);
      let getWali = dataWali?.find((x) => x.id === santri.id);
      let getWaNo = Commons.GetNoWa(getDataLain, getAyah, getIbu, getWali);
      return {
        id: santri.id,
        nama: santri?.nama,
        no_daftar: santri?.no_daftar,
        isBayarPendaftaran: getBayarRegistration ? 1 : 0,
        isBayarDaftarUlang: getBayarReRegistration ? 1 : 0,
        waNo: getWaNo,
        rawData: {
          bayarPendaftaran: getBayarRegistration,
          bayarReregistrasi: getBayarReRegistration
        }
      }
    });
  };


  const ShowTable = () => {
    if (loading) {
      return (<>
        <LoadingSkeleton size={8}></LoadingSkeleton>
      </>)
    }
    return (
      <>
        <DialogPembayaran rowDetail={selectedRow} isOpen={dialogOpen} handleClose={() => { setDialogOpen(false); loadData(); }}></DialogPembayaran>
        <DataGrid
          rows={pembayarans}
          columns={columns}
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={[5, 10]}
          checkboxSelection
          onRowClick={(e) => {
            setSelectedRow(e.row);
            setDialogOpen(true);
          }}
          disableMultipleRowSelection={true}
          sx={{ border: 0 }}
        />

      </>
    );
  }


  return (
    <>
      <Card>
        <CardHeader title="Pembayaran Management" sx={{ borderBottom: "1px solid #f4f4f4" }}>
        </CardHeader>
        <CardContent>
          <DialogPembayaran></DialogPembayaran>
          <Filter RunFilter={RunFilter} FilterTypeSudah={FILTER_TYPE.BAYAR_SUDAH} FilterTypeBelum={FILTER_TYPE.BAYAR_BELUM}></Filter>
          {ShowTable()}
        </CardContent>
      </Card>

    </>
  )
}

export default Bayar;